import gql from 'graphql-tag';

const optOutOnboardingQueueRecordMutation = gql`
  mutation OptOutOnboardingQueueRecord($input: OptOutOnboardingQueueRecordInput!) {
    optOutOnboardingQueueRecord(input: $input) {
      success
      errors
      onboardingQueueRecord {
        flatRateOfferId
        status
        reason
        completedAt
        updatedAt
        updatedBy
      }
    }
  }
`;

export default optOutOnboardingQueueRecordMutation;
